import { gql } from '@apollo/client';

export const GET_EXTERNAL_POSTS_QUERY = gql`
  query GetExternalPosts($hotelId: ID!) {
    externalPosts(where: { hotel: $hotelId }, sort: "updated_at:desc") {
      id
      bannerImg {
        id
        formats
        url
      }
      bannerImgUrl
      externalContent {
        id
        title
        body
        hashtags
        publicationState
        platform
      }
    }
  }
`;
